/* ------------------------------------------------------------------ */
/* Le temps ouvré (CDC §2.5, Q33)                                      */
/* ------------------------------------------------------------------ */
/** Lundi–vendredi hors jours fériés, 8 h 30 – 12 h 30 et 13 h 30 – 17 h 30, heure de Paris. */
export const PLAGES_OUVREES = [
    [8 * 60 + 30, 12 * 60 + 30],
    [13 * 60 + 30, 17 * 60 + 30],
];
export const MINUTES_OUVREES_PAR_JOUR = 8 * 60;
const UN_JOUR = 86_400_000;
/** Dimanche de Pâques (algorithme de Meeus, calendrier grégorien). */
function paques(annee) {
    const a = annee % 19;
    const b = Math.floor(annee / 100);
    const c = annee % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mois = Math.floor((h + l - 7 * m + 114) / 31);
    const jour = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(annee, mois - 1, jour);
}
const cacheFeries = new Map();
/**
 * Les onze jours fériés légaux de métropole, « AAAA-MM-JJ ». Calculés plutôt
 * que tenus en référentiel : la liste est fixée par la loi, et un référentiel
 * oublié en janvier fausse l'indicateur toute l'année. Le lundi de Pentecôte
 * en fait partie, même travaillé ici ou là au titre de la journée de solidarité.
 */
export function joursFeries(annee) {
    const deja = cacheFeries.get(annee);
    if (deja)
        return deja;
    const p = paques(annee);
    const iso = (t) => new Date(t).toISOString().slice(0, 10);
    const fixes = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map((md) => `${annee}-${md}`);
    const mobiles = [1, 39, 50].map((n) => iso(p + n * UN_JOUR)); // lundi de Pâques, Ascension, lundi de Pentecôte
    const out = new Set([...fixes, ...mobiles]);
    cacheFeries.set(annee, out);
    return out;
}
export function estJourFerie(jour) {
    return joursFeries(Number(jour.slice(0, 4))).has(jour);
}
const HEURE_PARIS = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
});
/**
 * L'heure MURALE de Paris, exprimée comme un instant UTC : 9 h à Paris devient
 * 9 h « UTC ». On compte ensuite en arithmétique UTC, sans fuseau. Les
 * changements d'heure tombent la nuit, hors des plages ouvrées : ils ne
 * faussent rien.
 */
function murale(d) {
    const p = {};
    for (const x of HEURE_PARIS.formatToParts(d))
        p[x.type] = x.value;
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
}
/** Minutes ouvrées entre deux instants (0 si `fin` précède `debut`). */
export function minutesOuvreesEntre(debut, fin) {
    const a = murale(debut);
    const b = murale(fin);
    if (b <= a)
        return 0;
    let ms = 0;
    for (let jour = Math.floor(a / UN_JOUR) * UN_JOUR; jour < b; jour += UN_JOUR) {
        const d = new Date(jour);
        const js = d.getUTCDay();
        if (js === 0 || js === 6 || estJourFerie(d.toISOString().slice(0, 10)))
            continue;
        for (const [de, a2] of PLAGES_OUVREES) {
            const s = Math.max(a, jour + de * 60_000);
            const e = Math.min(b, jour + a2 * 60_000);
            if (e > s)
                ms += e - s;
        }
    }
    return ms / 60_000;
}
const JOUR_PARIS = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' });
/** Le jour civil de Paris d'un instant, « AAAA-MM-JJ ». */
export const jourParis = (d) => JOUR_PARIS.format(d);
const HEURE_MURALE = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
/** L'heure murale de Paris d'un instant, « HH:MM ». */
export const heureParis = (d) => HEURE_MURALE.format(d);
const lendemain = (jour) => {
    const d = new Date(`${jour}T12:00:00Z`);
    d.setUTCDate(d.getUTCDate() + 1);
    return d.toISOString().slice(0, 10);
};
/** Les jours OUVRÉS écoulés de `debut` à `fin` : ceux de ]debut, fin], jours civils de Paris, hors week-end et fériés. */
export function joursOuvresEcoules(debut, fin) {
    let n = 0;
    const dernier = jourParis(fin);
    for (let j = lendemain(jourParis(debut)); j <= dernier; j = lendemain(j)) {
        const js = new Date(`${j}T12:00:00Z`).getUTCDay();
        if (js !== 0 && js !== 6 && !estJourFerie(j))
            n++;
    }
    return n;
}
const HEURE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit' });
const JOUR_SEMAINE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', weekday: 'long' });
/**
 * L'ANCIENNETÉ D'UNE DEMANDE, en jours OUVRÉS : « aujourd'hui, 9 h 15 »,
 * « hier, 16 h 30 », « vendredi, 16 h 30 » (un seul jour ouvré écoulé, à
 * cheval sur un week-end ou un férié), puis « il y a 3 jours ouvrés ».
 *
 * Écarté : l'ancienneté en heures (« il y a 22 heures »). Déposée la veille à
 * 17 h, une demande avait l'air du jour ; et un week-end comptait pour deux
 * jours de retard que personne n'avait eu à tenir. C'est le calendrier des
 * délais de traitement (CDC §2.5) qui fait foi.
 */
export function ancienneteOuvree(depuis, maintenant = new Date()) {
    const d = new Date(depuis);
    const heure = HEURE.format(d).replace(':', ' h ').replace(/^0/, '');
    const jour = jourParis(d);
    const aujourdhui = jourParis(maintenant);
    if (jour >= aujourdhui)
        return `aujourd’hui, ${heure}`;
    if (lendemain(jour) === aujourdhui)
        return `hier, ${heure}`;
    const n = joursOuvresEcoules(d, maintenant);
    if (n <= 1)
        return `${JOUR_SEMAINE.format(d)}, ${heure}`;
    return `il y a ${n} jours ouvrés`;
}
/* ------------------------------------------------------------------ */
/* Les engagements                                                     */
/* ------------------------------------------------------------------ */
export const CATEGORIES_REACTIVITE = ['bloquante', 'courante', 'gelee'];
export const REGLES_REACTIVITE = {
    bloquante: {
        libelle: 'Bloquantes',
        delaiMinutes: 4 * 60,
        objectif: 0.9,
        enClair: '90 % traitées en ½ journée (4 h ouvrées)',
    },
    courante: {
        libelle: 'Faibles et modérées',
        delaiMinutes: MINUTES_OUVREES_PAR_JOUR,
        objectif: 0.8,
        enClair: '80 % traitées en 1 journée (8 h ouvrées)',
    },
    gelee: {
        libelle: 'Passées par « Gelée »',
        delaiMinutes: 5 * MINUTES_OUVREES_PAR_JOUR,
        objectif: 0.9,
        enClair: '90 % traitées dans la semaine (5 jours ouvrés)',
    },
};
/** Le chrono court dans ces états, et dans eux seuls. */
const ETATS_CHRONO = new Set(['emise', 'prise_en_charge']);
/** Fenêtre glissante : les demandes clôturées sur les N derniers jours. */
export const FENETRE_REACTIVITE_JOURS = 30;
export const SCORE_MAX = 5;
/**
 * Le délai de traitement d'une demande clôturée, ou null si elle ne l'est pas.
 * La mesure s'arrête à la DERNIÈRE clôture : une demande rouverte puis
 * reclôturée compte son second traitement, sans le temps passé clôturée.
 *
 * Une demande passée par « Gelée » est jugée à la semaine, même bloquante :
 * elle dépendait d'un éditeur, et la tenir à la demi-journée la condamnait.
 *
 * Une demande que son demandeur a refermée encore « émise » (DEC-055) ne se
 * mesure pas : personne ne l'a traitée. La compter jugeait l'équipe sur le
 * temps qu'un client a mis à résoudre seul son problème.
 */
export function mesurerTraitement(d) {
    let fin = -1;
    d.transitions.forEach((t, i) => {
        if (t.vers === 'cloturee')
            fin = i;
    });
    if (fin < 0)
        return null;
    if (d.transitions[fin].de === 'emise')
        return null;
    let etat = 'emise';
    let depuis = new Date(d.dateDemande);
    let minutes = 0;
    let gelee = false;
    for (const t of d.transitions.slice(0, fin + 1)) {
        const quand = new Date(t.date);
        if (ETATS_CHRONO.has(etat))
            minutes += minutesOuvreesEntre(depuis, quand);
        if (t.vers === 'gelee')
            gelee = true;
        etat = t.vers;
        depuis = quand;
    }
    const categorie = gelee ? 'gelee' : d.urgence === 'bloquant' ? 'bloquante' : 'courante';
    return { categorie, minutes, dansDelai: minutes <= REGLES_REACTIVITE[categorie].delaiMinutes };
}
const arrondi1 = (x) => Math.round(x * 10) / 10;
/**
 * LE SCORE SUR 5 : par catégorie, 5 × (taux ÷ objectif), plafonné à 5 — un
 * objectif tenu vaut 5, qu'il soit de 80 ou de 90 %. Puis la moyenne des
 * catégories, pondérée par leur nombre de demandes. Écarté : le taux brut
 * (5 × part dans le délai), qui notait 4,5/5 une équipe tenant tous ses
 * objectifs et mélangeait des engagements différents.
 */
export function scoreReactivite(mesures) {
    const categories = CATEGORIES_REACTIVITE.map((c) => {
        const r = REGLES_REACTIVITE[c];
        const siennes = mesures.filter((m) => m.categorie === c);
        const dansDelai = siennes.filter((m) => m.dansDelai).length;
        const taux = siennes.length ? dansDelai / siennes.length : null;
        return {
            categorie: c,
            libelle: r.libelle,
            enClair: r.enClair,
            nombre: siennes.length,
            dansDelai,
            taux,
            objectif: r.objectif,
            score: taux === null ? null : arrondi1(Math.min(1, taux / r.objectif) * SCORE_MAX),
        };
    });
    const nombre = mesures.length;
    const somme = categories.reduce((s, c) => {
        if (c.taux === null)
            return s;
        return s + c.nombre * Math.min(1, c.taux / c.objectif) * SCORE_MAX;
    }, 0);
    return { score: nombre ? arrondi1(somme / nombre) : null, nombre, categories };
}
//# sourceMappingURL=reactivite.js.map